export default "__VITE_ASSET__VexicwX1__"